
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/social-event-policy",
      function () {
        return require("private-next-pages/terms/social-event-policy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/social-event-policy"])
      });
    }
  